package devxertech.com.pages.commons

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun WebDesignBoxes(
    image: String,
    text: String,
    imageWidth: CSSSizeValue<CSSUnit.px>,
    imageHeight: CSSSizeValue<CSSUnit.px>,
    imageTopMargin: CSSSizeValue<CSSUnit.px> = 0.px,
    imageBottomMargin: CSSSizeValue<CSSUnit.px> = 10.px,
    textTopPadding: CSSSizeValue<CSSUnit.px> = 0.px,
    textBottomPadding: CSSSizeValue<CSSUnit.px> = 10.px
) {
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()

    val imageWidthByBreakpoint = when (breakpoint) {
        Breakpoint.SM -> 35.px
        Breakpoint.MD -> 50.px
        Breakpoint.LG -> imageWidth
        Breakpoint.XL -> imageWidth
        else -> imageWidth
    }
    val imageHeightByBreakpoint = when (breakpoint) {
        Breakpoint.SM -> 35.px
        Breakpoint.MD -> 50.px
        Breakpoint.LG -> imageHeight
        Breakpoint.XL -> imageHeight
        else -> imageHeight
    }

    Box(modifier = Modifier.margin(bottom = if (breakpoint < Breakpoint.MD) 25.px else if (breakpoint == Breakpoint.LG) 20.px else 0.px)
        .width(
            if (breakpoint > Breakpoint.LG) 203.px
            else if (breakpoint == Breakpoint.LG) 170.px
            else if (breakpoint >= Breakpoint.MD) 160.px
            else 150.px)
        .height(
            if (breakpoint > Breakpoint.LG) 103.px
            else if (breakpoint == Breakpoint.LG) 90.px
            else if (breakpoint >= Breakpoint.MD) 103.px
            else 90.px)
        .borderRadius(5.px, 40.px, 5.px, 40.px)
        .border(
            width = 1.px,
            color = sitePalette.commonSecondaryButtonColor.rgb,
            style = LineStyle.Solid)
        .boxShadow(
            blurRadius = 3.px,
            spreadRadius = 0.px,
            color = sitePalette.specialButtonBorderColor.rgb),
        contentAlignment = Alignment.Center
    ) {
        Column(modifier = Modifier,
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Image(src = image, modifier = Modifier.width(imageWidthByBreakpoint).height(imageHeightByBreakpoint)
                .margin(top = imageTopMargin, bottom = imageBottomMargin,))
            SpanText(text = text, modifier = Modifier
                .fontFamily(Constants.FONT_FAMILY)
                .fontSize(if (breakpoint < Breakpoint.MD) 13.px else if (breakpoint == Breakpoint.LG) 12.px else 16.px)
                .color(sitePalette.commonSecondaryButtonColor.rgb)
                .textAlign(TextAlign.Center)
                .margin(top = textTopPadding, bottom = textBottomPadding)
            )
        }
    }
}